import $ from 'jquery';

const $body = $('body');
const inBackend = $body.hasClass('neos-backend');


$('.event-list-item-collapse').each(function () {

    if (inBackend) return;

    const $element = $(this);
    const $collapse = $element.find('.event-list-item-collapse');
    const $content = $element.find('.event-list-item-content');


    // Initially hide content
    $content.hide();

    $collapse.on('click', function () {
        $element.toggleClass('collapsed');
        $content.slideToggle();
    });

});



$('.event-list').each(function () {

    if (inBackend) return;

    const $eventList = $(this);
    const $events = $eventList.find('.event-list-item');
    const $categoryButtons = $eventList.find('.event-list-category');
    const $months = $eventList.find('.event-list-month');

    $categoryButtons.filter('[data-identifier="all"]').addClass('active');


    $categoryButtons.on('click', function () {

        const $button = $(this);
        const identifier = $button.data('identifier');

        $button.addClass('active').siblings().removeClass('active');

        $events.each(function () {
            const $event = $(this);
            const categories = $event.data('categories');

            // Check if event has category
            if ('all' === identifier || categories.indexOf(identifier) !== -1) {
                $event.removeClass('event-list-hidden');
            } else {
                $event.addClass('event-list-hidden');
            }
        });

        showHideMonths();

    });


    function showHideMonths() {
        $months.each(function () {
            const $month = $(this);
            const $events = $month.find('.event-list-item').not('.event-list-hidden');
            if ($events.length) {
                $month.removeClass('event-list-hidden');
            } else {
                $month.addClass('event-list-hidden');
            }
        });
    }


});


